import React from 'react'
import { Card, Badge, Space, Typography } from 'antd'

const { Text } = Typography

const STATUS_CONFIG = [
  { key: 'waiting', color: '#1890ff', label: 'Wait' },
  { key: 'active', color: '#52c41a', label: 'Active' },
  { key: 'completed', color: '#8c8c8c', label: 'Done' },
  { key: 'failed', color: '#ff4d4f', label: 'Fail' },
  { key: 'delayed', color: '#fa8c16', label: 'Delay' },
]

const QueueCard = ({ queue, selected, onClick }) => {
  const { name, counts = {} } = queue

  return (
    <Card
      hoverable
      onClick={onClick}
      style={{
        borderColor: selected ? '#1890ff' : undefined,
        borderWidth: selected ? 2 : 1,
      }}
      styles={{ body: { padding: '12px 16px' } }}
    >
      <Text strong style={{ fontSize: 14, textTransform: 'capitalize' }}>{name}</Text>
      <div style={{ marginTop: 8, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
        {STATUS_CONFIG.map(({ key, color, label }) => (
          <Space key={key} size={4}>
            <Badge color={color} />
            <Text type="secondary" style={{ fontSize: 12 }}>{label}</Text>
            <Text strong style={{ fontSize: 12 }}>{counts[key] || 0}</Text>
          </Space>
        ))}
      </div>
    </Card>
  )
}

export default QueueCard
